"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { useCompactMode } from "@/contexts/CompactModeContext";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { getFileInfoFromUrl } from "@/helpers/file.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { useContext } from "react";
import WaveDropActionsAddReaction from "./WaveDropActionsAddReaction";
import WaveDropActionsBoost from "./WaveDropActionsBoost";
import WaveDropActionsCopyLink from "./WaveDropActionsCopyLink";
import WaveDropActionsDownload from "./WaveDropActionsDownload";
import WaveDropActionsEdit from "./WaveDropActionsEdit";
import WaveDropActionsMarkUnread from "./WaveDropActionsMarkUnread";
import WaveDropActionsOpen from "./WaveDropActionsOpen";
import WaveDropActionsOptions from "./WaveDropActionsOptions";
import WaveDropActionsQuote from "./WaveDropActionsQuote";
import WaveDropActionsRate from "./WaveDropActionsRate";
import WaveDropActionsReply from "./WaveDropActionsReply";
import WaveDropActionsToggleLinkPreview from "./WaveDropActionsToggleLinkPreview";
import WaveDropFollowAuthor from "./WaveDropFollowAuthor";
interface WaveDropActionsProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly showVoting?: boolean | undefined;
  readonly onReply: () => void;
  readonly onQuote: () => void;
  readonly onEdit?: (() => void) | undefined;
}
export default function WaveDropActions(t0) {
  const $ = _c(63);
  const {
    drop,
    activePartIndex,
    showVoting: t1,
    onReply,
    onQuote,
    onEdit
  } = t0;
  const showVoting = t1 === undefined ? true : t1;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const {
    canDelete
  } = useDropInteractionRules(drop);
  const {
    isMemesWave
  } = useSeizeSettings();
  const compact = useCompactMode();
  let t2;
  if ($[0] !== drop.drop_type || $[1] !== drop.wave || $[2] !== isMemesWave || $[3] !== showVoting) {
    t2 = showVoting && !(drop.drop_type === ApiDropType.Participatory && isMemesWave(drop.wave.id));
    $[0] = drop.drop_type;
    $[1] = drop.wave;
    $[2] = isMemesWave;
    $[3] = showVoting;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const shouldShowVoting = t2;
  const t3 = `tw-absolute tw-right-2 tw-z-20 ${compact ? "-tw-top-4" : "tw-top-0"} tw-opacity-0 tw-transition-opacity tw-duration-200 tw-ease-in-out group-hover:tw-opacity-100`;
  let t4;
  if ($[5] !== drop) {
    t4 = <WaveDropActionsToggleLinkPreview drop={drop} />;
    $[5] = drop;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== activePartIndex || $[8] !== connectedProfile?.handle || $[9] !== drop) {
    t5 = connectedProfile?.handle !== drop.author.handle && !activePartIndex && <WaveDropFollowAuthor drop={drop} />;
    $[7] = activePartIndex;
    $[8] = connectedProfile?.handle;
    $[9] = drop;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== drop) {
    t6 = <WaveDropActionsMarkUnread drop={drop} />;
    $[11] = drop;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== activePartIndex || $[14] !== drop || $[15] !== onReply) {
    t7 = <WaveDropActionsReply onReply={onReply} drop={drop} activePartIndex={activePartIndex} />;
    $[13] = activePartIndex;
    $[14] = drop;
    $[15] = onReply;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== activePartIndex || $[18] !== drop || $[19] !== onQuote) {
    t8 = <WaveDropActionsQuote onQuote={onQuote} drop={drop} activePartIndex={activePartIndex} />;
    $[17] = activePartIndex;
    $[18] = drop;
    $[19] = onQuote;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t10;
  let t9;
  if ($[21] !== drop) {
    t9 = <WaveDropActionsCopyLink drop={drop} />;
    t10 = <WaveDropActionsOpen drop={drop} />;
    $[21] = drop;
    $[22] = t10;
    $[23] = t9;
  } else {
    t10 = $[22];
    t9 = $[23];
  }
  let t11;
  if ($[24] !== drop.id || $[25] !== drop.parts) {
    bb0: {
      const media = drop.parts.at(0)?.media.at(0);
      const url = media?.url;
      if (!url) {
        t11 = null;
        break bb0;
      }
      const info = getFileInfoFromUrl(url);
      if (!info) {
        t11 = null;
        break bb0;
      }
      const t12 = `download-media-${drop.id}`;
      let t13;
      if ($[27] !== info.extension || $[28] !== info.name || $[29] !== t12 || $[30] !== url) {
        t13 = <WaveDropActionsDownload href={url} name={info.name} extension={info.extension} tooltipId={t12} />;
        $[27] = info.extension;
        $[28] = info.name;
        $[29] = t12;
        $[30] = url;
        $[31] = t13;
      } else {
        t13 = $[31];
      }
      t11 = t13;
    }
    $[24] = drop.id;
    $[25] = drop.parts;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[32] !== drop || $[33] !== onEdit) {
    t12 = onEdit && drop.drop_type !== ApiDropType.Participatory && <WaveDropActionsEdit drop={drop} onEdit={onEdit} />;
    $[32] = drop;
    $[33] = onEdit;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== canDelete || $[36] !== drop) {
    t13 = canDelete && <WaveDropActionsOptions drop={drop} />;
    $[35] = canDelete;
    $[36] = drop;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  let t15;
  if ($[38] !== drop) {
    t14 = <WaveDropActionsAddReaction drop={drop} />;
    t15 = <WaveDropActionsBoost drop={drop} />;
    $[38] = drop;
    $[39] = t14;
    $[40] = t15;
  } else {
    t14 = $[39];
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t10 || $[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== t14 || $[46] !== t15 || $[47] !== t4 || $[48] !== t5 || $[49] !== t6 || $[50] !== t7 || $[51] !== t8 || $[52] !== t9) {
    t16 = <div className="tw-flex tw-h-8 tw-items-center tw-rounded-lg tw-bg-iron-950 tw-shadow tw-ring-1 tw-ring-inset tw-ring-iron-800">{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}</div>;
    $[41] = t10;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
    $[47] = t4;
    $[48] = t5;
    $[49] = t6;
    $[50] = t7;
    $[51] = t8;
    $[52] = t9;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  let t17;
  if ($[54] !== drop || $[55] !== shouldShowVoting) {
    t17 = shouldShowVoting && <WaveDropActionsRate drop={drop} />;
    $[54] = drop;
    $[55] = shouldShowVoting;
    $[56] = t17;
  } else {
    t17 = $[56];
  }
  let t18;
  if ($[57] !== t16 || $[58] !== t17) {
    t18 = <div className="tw-flex tw-items-center tw-gap-x-2">{t16}{t17}</div>;
    $[57] = t16;
    $[58] = t17;
    $[59] = t18;
  } else {
    t18 = $[59];
  }
  let t19;
  if ($[60] !== t18 || $[61] !== t3) {
    t19 = <div className={t3}>{t18}</div>;
    $[60] = t18;
    $[61] = t3;
    $[62] = t19;
  } else {
    t19 = $[62];
  }
  return t19;
}